// export const TweetsInfo = (tweetsArray: any, likesArray: any) => {
//     const tweets = tweetsArray.map((tweet: any) => {


//         console.log("TWEET__0", likesArray.includes(tweet.publicKey.toString()), "PUB_KEYS", tweet.publicKey.toString());
        
//         const likes = likeCounter(likesArray, tweet.publicKey.toString());

//         return {...tweet, likes: likes}
//     })

//     return tweets;
// }

export const TweetsInfo = (tweetsArray: any, likesArray:any) => {
    const tweets = tweetsArray.map((tweet: any) => {


        // console.log("TWEET__0", likesArray.includes(tweet.publicKey.toString()), "PUB_KEYS", tweet.publicKey.toString());
        
        const likes = likeCounter(likesArray, tweet.publicKey.toString());

        return {...tweet, likes: likes.count, likesAddress: likes.likeAddress}
    })

    return tweets;
}

// function likeCounter (likesArray: any, pubkey: any) {
//  let count = 0;
//     for(let key in likesArray) {
//         if (likesArray[key] === pubkey) {
//             count += 1;
//         }
//  }
//  return count;
// } 

function likeCounter (likesArray: any, pubkey: any) {
    let count = 0;
    let likeAddress;
       for(let key in likesArray) {
           if (likesArray[key].tweetAddress.toString() === pubkey) {
               count += 1;
               likeAddress = likesArray[key].likeAddress
           }
    }
    return {count,likeAddress};
   } 